import type { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import React, { useState } from 'react'
import styles from '../styles/Home.module.css'

const Home = ({}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const [roomCode, setRoomCode] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  // Форматирует код комнаты: добавляет дефис перед последними 3 цифрами
  // Примеры: 442149 → 442-149, 44149 → 44-149, 4-484452 → 4484-452
  const formatRoomCode = (value: string): string => {
    // Убираем всё кроме цифр (включая любые дефисы)
    const digits = value.replace(/\D/g, '')
    
    if (digits.length <= 3) {
      return digits
    }
    
    // Всегда ставим дефис перед последними 3 цифрами
    // meet_id - всё кроме последних 3, company_id - последние 3
    const meetId = digits.slice(0, -3)
    const companyId = digits.slice(-3)
    return `${meetId}-${companyId}`
  }

  // Нормализует код для отправки на сервер (добавляет дефис если его нет)
  const normalizeCodeForApi = (value: string): string => {
    const cleaned = value.replace(/[^\d-]/g, '')
    
    // Если дефис уже есть - возвращаем как есть
    if (cleaned.includes('-')) {
      return cleaned
    }
    
    // Только цифры - добавляем дефис перед последними 3 цифрами
    const digits = cleaned
    if (digits.length <= 3) {
      return digits
    }
    
    const meetId = digits.slice(0, -3)
    const companyId = digits.slice(-3)
    return `${meetId}-${companyId}`
  }

  const handleJoinRoom = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (!roomCode.trim()) {
      setError('Введите ID комнаты')
      return
    }

    setIsLoading(true)

    try {
      // Нормализуем код (добавляем дефис если его нет)
      const normalizedCode = normalizeCodeForApi(roomCode.trim())
      const response = await fetch(`/api/check_room?code=${encodeURIComponent(normalizedCode)}`)
      console.log('Frontend: response status', response.status)
      const data = await response.json()
      console.log('Frontend: response data', data)

      if (data.success && data.exists && data.redirectUrl) {
        console.log('Frontend: redirecting to', data.redirectUrl)
        // Используем window.location для полноценного серверного запроса
        // чтобы middleware установил нужные cookies
        window.location.href = data.redirectUrl
      } else {
        console.log('Frontend: room not found', data)
        setError('Неверный код. Комната с таким ID не найдена.')
      }
    } catch (err) {
      console.error('Error checking room:', err)
      setError('Произошла ошибка при проверке комнаты. Попробуйте ещё раз.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <img src="/images/proofix-logo.png" alt="Proofix Meet" style={{ marginBottom: '1.5rem' }} />
        </div>
        
        <div className={styles.tabContainer}>
          <div className={styles.tabContent}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '1.25rem', 
              fontWeight: 600, 
              textAlign: 'center',
              color: 'white'
            }}>
              Присоединиться к встрече
            </h2>
            <p style={{ 
              margin: '0.5rem 0 1.5rem', 
              fontSize: '0.875rem',
              color: 'rgba(255, 255, 255, 0.6)', 
              textAlign: 'center' 
            }}>
              Введите ID комнаты
            </p>
            
            <form className="lk-username-container" onSubmit={handleJoinRoom} style={{ gap: '1.25rem' }}>
              <input
                className="lk-form-control"
                id="roomCode"
                name="roomCode"
                type="text"
                autoComplete="off"
                value={roomCode}
                onChange={(e) => {
                  const formatted = formatRoomCode(e.target.value)
                  setRoomCode(formatted)
                  setError('')
                }}
                placeholder="ID комнаты"
                maxLength={10}
                disabled={isLoading}
              />
              
              {error && (
                <p style={{ 
                  margin: 0, 
                  color: '#ff6b6b', 
                  fontSize: '0.8125rem',
                  textAlign: 'center',
                  padding: '0.5rem 0.75rem',
                  background: 'rgba(255, 107, 107, 0.1)',
                  borderRadius: '0.375rem',
                  border: '1px solid rgba(255, 107, 107, 0.2)'
                }}>
                  {error}
                </p>
              )}
              
              <button
                type="submit"
                className="lk-button lk-join-button"
                disabled={isLoading || !roomCode.trim()}
                style={{ marginTop: '0.75rem', marginLeft:'10px' }}
              >
                {isLoading ? 'Проверка...' : 'Присоединиться'}
              </button>
            </form>
          </div>
        </div>
      </main>
      <footer data-lk-theme="default">
      </footer>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<{}> = async ({
  res,
}) => {
  res.setHeader('Cache-Control', 'public, max-age=7200')
  return { props: {} }
}

export default Home
